import React from 'react';

const ManageCMS = () => {
  return <div>CMS Management</div>;
};

export default ManageCMS;
